export default __webpack_public_path__ + "static/media/icons-user.569882d9.svg";